
import { PlaylistModel } from '@/models'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Playlist extends Vue {
    playlistName = ''

    get playlists(): PlaylistModel[] {
        return this.$store.getters['playlistModule/getTopPlaylists'] || []
    }

    get current() {
        return this.$store.getters['getCurrent']
    }

    createPlaylist() {
        const name = this.playlistName.trim()
        if (!name) {
            return
        }

        this.$store.dispatch('playlistModule/createPlaylist', name).then((playlist: PlaylistModel | null) => {
            this.playlistName = ''
            if (playlist) {
                this.$router.push('/playlist/tracks/' + playlist.id)
            }
        })
    }

    deletePlaylist(id: string) {
        this.$store.dispatch('playlistModule/deletePlaylist', id)
    }

    addCurrentTrack(playlistId: string) {
        if (!this.current) {
            return
        }

        this.$store.dispatch('playlistModule/addTrackToPlaylist', {
            playlistId,
            track: this.current,
        })
    }

    openPlaylist(id: string) {
        this.$router.push('/playlist/tracks/' + id)
    }

    formatDate(value: string) {
        if (!value) {
            return 'today'
        }

        return new Date(value).toLocaleDateString()
    }

    mounted() {
        window.scrollTo(0, 0)
        this.$store.dispatch('playlistModule/loadPlaylists')
    }
}
